import React from 'react';
import styled from '@emotion/styled';

import respond from '../../styles/mediaQueries';

const StyledHeader = styled('h2')`
    margin-bottom: 12rem;
    margin-left: auto;
    max-width: 80rem;
    text-align: right;

    ${respond('bp4')} {
        margin-bottom: 8rem;
        border-bottom: none;
        padding-bottom: 0;
    }
`;

const CaseStudySectionHeader = ({ children }) => {
	return <StyledHeader>{children}</StyledHeader>;
};

export default CaseStudySectionHeader;
